"use client";
import React, { useState } from "react";
import { handleCopyText } from "@/shared/utilities";

export interface Props {
  text: string;
  children: React.ReactNode;
  className?: string;
}

const Copy = ({ text, children, className }: Props) => {
  const [disabled, setDisabled] = useState<boolean>(false);

  return (
    <button
      className={className}
      disabled={disabled}
      onClick={() => handleCopyText(text, setDisabled)}
    >
      {disabled ? "Copied" : children}
    </button>
  );
};

export default Copy;
